// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3szjE","errorLogs":"EditorFooter_errorLogs__22oFM"};